import { EducationIcons } from "@/data/icons"
import { portfolioData } from "@/data/portfolioData"
import { Card, CardContent } from "@/components/ui-lab/card"
import { FaUniversity } from "react-icons/fa"
import { GiTiedScroll } from "react-icons/gi"

export const MyEducation = () => {
  const { education } = portfolioData
  const Icon = (level: string) => {
    const LevelIcon = EducationIcons[level] || FaUniversity
    return <LevelIcon className="text-lg" />
  }
  return (
    <>
      <h2 className="text-3xl font-semibold mb-6 flex items-center gap-2" suppressHydrationWarning>
        <GiTiedScroll /> Education
      </h2>
      <div className="flex flex-col lg:flex-row gap-2">
        {education.map((edu, idx) => (
          <Card
            key={idx}
            className="shadow-lg hover:shadow-2xl transition-all duration-300 hover:border-teal-500 border-2 border-transparent"
          >
            <CardContent className="p-6">
              <div className="flex items-start gap-4">
                <div className="text-teal-700 dark:text-teal-400 transition-all duration-300 hover:scale-110 mt-2">
                  {Icon(edu.level)}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold mb-1">{edu.degree}</h3>
                  <span className="font-semibold text-teal-700 dark:text-teal-400">{edu.institution}</span>
                  <br />
                  <span className="text-muted-foreground">{edu.location}</span>
                  <br />
                  <span className="text-muted-foreground">
                    {edu.start_year ? edu.start_year : "N/A"} - {edu.end_year ? edu.end_year : "N/A"}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  )
}
